import { Container, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { getParentSiteUrl, getDeployment } from '../../../../siteurl'
import {
  Anontools,
  LanguageSelector,
  Logo,
  Navigation,
  SearchWidget,
} from '@plone/volto/components';


const Header = ({ pathname }) => {
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const deployment = getDeployment();

  return (
    <Segment basic className="header-wrapper" role="banner">
      <Container>
        <div className="header">
          {(deployment) && (<div className="deployment">{deployment}</div>)}  
          <div className="logo-nav-wrapper">
              <div className="logo">
                <a href={getParentSiteUrl()} alt="Holyoake by Price (New Zealand) - Holyoake Air Management Solutions by Price"><Logo /></a>
              </div>
            <Navigation pathname={pathname} />
          </div>
          <div className="tools-search-wrapper">
            <LanguageSelector />
            {!token && (
              <div className="tools">
                <Anontools />
              </div>
            )}
          </div>
        </div>
      </Container>
    </Segment>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
